import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Lightbox from "./Lightbox";
import GalleryComment from "./GalleryComment";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const PicturesTab = ({ handleImageGallery, pics, comments }) => {
  const [activeTab, setActiveTab] = React.useState(0);

  const changeActiveTab = (event, newTab) => {
    setActiveTab(newTab);
  };
  return (
    <div className="PicturesTab">
      <div className="HeadReturn">
        <span>تصاویر مربوط به لاستیک دنا</span>
        <span onClick={handleImageGallery}>&#x2613;</span>
      </div>
      <Box sx={{ width: "100%" }} className="PicturesTabBox">
        <Box
          sx={{ borderBottom: 1, borderColor: "divider" }}
          className="PicturesTabs"
        >
          <Tabs
            value={activeTab}
            onChange={changeActiveTab}
            aria-label="basic tabs example"
          >
            <Tab label="تصاویر محصول" />
            <Tab label="دیدگاه های من" />
          </Tabs>
        </Box>
        <TabPanel value={activeTab} index={0}>
          <Lightbox picProduct={pics} />
        </TabPanel>
        <TabPanel value={activeTab} index={1}>
          <GalleryComment comments={comments} />
        </TabPanel>
      </Box>
    </div>
  );
};

export default PicturesTab;
